export default {
  // Header
  'header.temple.name': '천축선원',
  'header.temple.english': 'Cheonchuk Seonwon',
  'header.menu.introduction': '선원 소개',
  'header.menu.greeting': '인사말',
  'header.menu.history': '천축선원의 역사',
  'header.menu.meaning': '기원정사의 의미',
  'header.menu.location': '위치 / 오시는 길',
  'header.menu.practice': '수행/법문',
  'header.menu.pilgrimage': '순례성지',
  'header.menu.news': '소식',
  'header.menu.resources': '자료실',
  'header.menu.support': '참여/후원',

  // Hero Section
  'hero.title': '천축선원에 오신 것을 환영합니다',
  'hero.subtitle': '부처님의 가르침이 시작된 성지, 인도 기원정사에서',
  'hero.description': '천축선원은 인도 비하르주 라즈기르에 위치한 한국 불교 수행 도량입니다. 부처님께서 깨달음을 얻으신 후 처음으로 설법하신 성지에서 참선과 수행의 길을 걷고 있습니다.',
  'hero.button.visit': '방문 안내',
  'hero.button.learn': '더 알아보기',

  // Daily Wisdom
  'wisdom.title': '오늘의 법구경',
  'wisdom.original': '若以色見我 以音聲求我 是人行邪道 不能見如來',
  'wisdom.korean': '만약 나를 색(형상)으로 보려 하거나, 음성으로 찾으려 한다면, 그 사람은 삿된 길을 가고 있는 것이다. 그는 결코 여래를 볼 수 없다.',
  'wisdom.english': 'If you\'re trying to see me in colour, or in voice, he\'s on a dead path; he can never see the Buddha.',

  // Quick Links
  'links.title': '빠른 안내',
  'links.visit.title': '참배 안내',
  'links.visit.morning': '오전 예불',
  'links.visit.morning.time': '04:00-06:00',
  'links.visit.evening': '오후 예불',
  'links.visit.evening.time': '18:00-19:00',
  'links.visit.lunch': '점심시간',
  'links.visit.lunch.time': '12:00-13:00',
  'links.visit.contact': '방문 전 연락 필수',
  'links.visit.phone': '+91-892-313-9035',
  'links.visit.manager': '(총괄 메니저 와르단)',
  'links.practice.title': '수행 프로그램',
  'links.practice.meditation': '참선 수행',
  'links.practice.dharma': '법문 청취',
  'links.practice.retreat': '템플스테이',
  'links.support.title': '후원 안내',
  'links.support.regular': '정기 후원',
  'links.support.onetime': '일시 후원',
  'links.support.volunteer': '자원봉사',

  // News Section
  'news.title': '선원 소식',
  'news.view': '자세히 보기',
  'news.date': '날짜',

  // Footer
  'footer.about.title': '천축선원 소개',
  'footer.about.description': '천축선원은 부처님의 성지 인도 라즈기르에 위치한 한국 불교 수행 도량입니다.',
  'footer.contact.title': '연락처',
  'footer.contact.address': '인도 비하르주 라즈기르',
  'footer.contact.phone': '전화',
  'footer.contact.email': '이메일',
  'footer.links.title': '바로가기',
  'footer.links.introduction': '선원 소개',
  'footer.links.practice': '수행 안내',
  'footer.links.pilgrimage': '순례 안내',
  'footer.links.support': '후원 안내',
  'footer.hours.title': '참배 시간',
  'footer.hours.morning': '오전 예불: 04:00-06:00',
  'footer.hours.evening': '오후 예불: 18:00-19:00',
  'footer.hours.lunch': '점심시간: 12:00-13:00',
  'footer.copyright': '© 2024 천축선원. All rights reserved.',
  'footer.powered': 'Website Builder',
};
